// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Oo9R","left":"InfoRow_left__16TcX"};